export const geolocation = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BQ: 'Bonaire, Saint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, The Democratic Republic of the',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: 'Cote d Ivoire',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curacao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Malvinas Islands',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'Korea, Democratic Peoples Republic of',
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Lao Peoples Democratic Republic',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, The Former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  PS: 'Palestinian Territory',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and The Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan, Province of China',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

export const geolocationES = {
  AF: 'Afganistán',
  AL: 'Albania',
  DZ: 'Argelia',
  AS: 'Samoa Americana',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguila',
  AG: 'Antigua y Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaiyán',
  BS: 'Bahamas',
  BH: 'Baréin',
  BD: 'Bangladés',
  BB: 'Barbados',
  BY: 'Bielorrusia',
  BE: 'Bélgica',
  BZ: 'Belice',
  BJ: 'Benín',
  BM: 'Bermudas',
  BT: 'Bután',
  BO: 'Bolivia',
  BA: 'Bosnia y Herzegovina',
  BW: 'Botsuana',
  BR: 'Brasil',
  IO: 'Territorio Británico del Océano Índico',
  VG: 'Islas Vírgenes Británicas',
  BN: 'Brunéi',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Camboya',
  CM: 'Camerún',
  CA: 'Canadá',
  CV: 'Cabo Verde',
  KY: 'Islas Caimán',
  CF: 'República Centroafricana',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoras',
  CG: 'República del Congo',
  CD: 'República Democrática del Congo',
  CK: 'Islas Cook',
  CR: 'Costa Rica',
  CI: 'Costa de Marfil',
  HR: 'Croacia',
  CU: 'Cuba',
  CW: 'Curazao',
  CY: 'Chipre',
  CZ: 'Chequia',
  DK: 'Dinamarca',
  DJ: 'Yibuti',
  DM: 'Dominica',
  DO: 'República Dominicana',
  EC: 'Ecuador',
  EG: 'Egipto',
  SV: 'El Salvador',
  GQ: 'Guinea Ecuatorial',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Esuatini',
  ET: 'Etiopía',
  FJ: 'Fiyi',
  FI: 'Finlandia',
  FR: 'Francia',
  GF: 'Guayana Francesa',
  PF: 'Polinesia Francesa',
  GA: 'Gabón',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Alemania',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Grecia',
  GL: 'Groenlandia',
  GD: 'Granada',
  GP: 'Guadalupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GN: 'Guinea',
  GW: 'Guinea-Bisáu',
  GY: 'Guyana',
  HT: 'Haití',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungría',
  IS: 'Islandia',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Irán',
  IQ: 'Irak',
  IE: 'Irlanda',
  IL: 'Israel',
  IT: 'Italia',
  JM: 'Jamaica',
  JP: 'Japón',
  JO: 'Jordania',
  KZ: 'Kazajistán',
  KE: 'Kenia',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Kirguistán',
  LA: 'Laos',
  LV: 'Letonia',
  LB: 'Líbano',
  LS: 'Lesoto',
  LR: 'Liberia',
  LY: 'Libia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LU: 'Luxemburgo',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malaui',
  MY: 'Malasia',
  MV: 'Maldivas',
  ML: 'Malí',
  MT: 'Malta',
  MH: 'Islas Marshall',
  MQ: 'Martinica',
  MR: 'Mauritania',
  MU: 'Mauricio',
  YT: 'Mayotte',
  MX: 'México',
  FM: 'Micronesia',
  MD: 'Moldavia',
  MC: 'Mónaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marruecos',
  MZ: 'Mozambique',
  MM: 'Birmania',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Países Bajos',
  NC: 'Nueva Caledonia',
  NZ: 'Nueva Zelanda',
  NI: 'Nicaragua',
  NE: 'Níger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Isla Norfolk',
  KP: 'Corea del Norte',
  MP: 'Islas Marianas del Norte',
  NO: 'Noruega',
  OM: 'Omán',
  PK: 'Pakistán',
  PW: 'Palaos',
  PS: 'Palestina',
  PA: 'Panamá',
  PG: 'Papúa Nueva Guinea',
  PY: 'Paraguay',
  PE: 'Perú',
  PH: 'Filipinas',
  PL: 'Polonia',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Catar',
  RE: 'Reunión',
  RO: 'Rumanía',
  RU: 'Rusia',
  RW: 'Ruanda',
  BL: 'San Bartolomé',
  SH: 'Santa Elena',
  KN: 'San Cristóbal y Nieves',
  LC: 'Santa Lucía',
  MF: 'San Martín',
  PM: 'San Pedro y Miquelón',
  VC: 'San Vicente y las Granadinas',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Santo Tomé y Príncipe',
  SA: 'Arabia Saudita',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leona',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Eslovaquia',
  SI: 'Eslovenia',
  SB: 'Islas Salomón',
  SO: 'Somalia',
  ZA: 'Sudáfrica',
  KR: 'Corea del Sur',
  SS: 'Sudán del Sur',
  ES: 'España',
  LK: 'Sri Lanka',
  SD: 'Sudán',
  SR: 'Surinam',
  SE: 'Suecia',
  CH: 'Suiza',
  SY: 'Siria',
  TW: 'Taiwán',
  TJ: 'Tayikistán',
  TZ: 'Tanzania',
  TH: 'Tailandia',
  TL: 'Timor Oriental',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad y Tobago',
  TN: 'Túnez',
  TR: 'Turquía',
  TM: 'Turkmenistán',
  TC: 'Islas Turcas y Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ucrania',
  AE: 'Emiratos Árabes Unidos',
  GB: 'Reino Unido',
  US: 'Estados Unidos',
  UM: 'Islas Ultramarinas Menores de Estados Unidos',
  UY: 'Uruguay',
  UZ: 'Uzbekistán',
  VU: 'Vanuatu',
  VA: 'Ciudad del Vaticano',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VI: 'Islas Vírgenes de los Estados Unidos',
  WF: 'Wallis y Futuna',
  EH: 'Sahara Occidental',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabue',
};
